import { getElement, ifSelectorExist, getCookie } from './utils';

export const locationModal = () => {
    let modalWindow = getElement('.location-modal-window');
    let modalWindowClose = getElement('.location-modal-window--close');
    let modalWindowBtn = getElement('.location-modal-window--button');
    let modalWindowOpen = getElement('.location-modal-window--open');
    let modalWindowCitySelect = getElement('#city-select');
    let checkBodyClass = getElement('.no-phone-swap');
    const noPhoneSwapModal = getElement('body').classList.contains('no-phone-swap');
    const pageSelectedLocationSwapModal = getElement('.body').getAttribute('data-page-selected-location');
    if (!noPhoneSwapModal && !pageSelectedLocationSwapModal) {
            // Functions
    let openModal = () => {
        if (!ifSelectorExist(checkBodyClass)) {
            modalWindow.classList.add('open');
            document.body.style.overflow = 'hidden';
        }
    }

    let closeModal = () => {
        modalWindow.classList.add('fade-out');
        setTimeout(() => {
            modalWindow.classList.remove('open', 'fade-out');
            document.body.style.overflow = null;
        }, 300);
    }


    if (ifSelectorExist(modalWindowOpen)) {
        modalWindowOpen.addEventListener('click', () => {
            console.log('clicked')
            openModal();
        })
    }

    if (ifSelectorExist(modalWindow)) {

        if (localStorage.getItem('selectedLocation') == null & localStorage.getItem('selectedLocation') == undefined) {
            openModal();
        }

        modalWindow.addEventListener('click', (e) => {
            if (e.target === modalWindow) {
                closeModal();
            }
        });

        window.onkeydown = (e) => {
            if (e.key === "Escape") {
                closeModal();
            }
        }
    }

    if (ifSelectorExist(modalWindowClose)) {
        modalWindowClose.addEventListener('click', () => {
            closeModal();
        })
    }

    if (ifSelectorExist(modalWindowBtn)) {
        modalWindowBtn.addEventListener('click', () => {
            closeModal();
            localStorage.setItem('userOverride', true); // User has made a selection
            location.reload();
        })
    }

    modalWindowCitySelect.addEventListener('change', () => {
        let selectedOption = modalWindowCitySelect.options[modalWindowCitySelect.selectedIndex].text;
        getElement('.insert-city', modalWindowOpen).textContent = selectedOption;
    })
    }
}